import { ROLE } from '../../../enums/roles';
import { STORE } from '../../../enums/store';
export default {
    authorized_locations(state, getters, rootState) {
        const user = rootState[STORE.AUTH].user;
        if (user) {
            // Only Customer & Supplier are restricted to their assigned locations.
            // Every other role (System Admin, Admin, Manager, etc.) sees all
            // locations — matching backend User::hasLocationRestriction().
            if (user.role_id !== ROLE.CUSTOMER && user.role_id !== ROLE.SUPPLIER) {
                return state.locations;
            }
            return user.location ? state.locations.filter(x => user.location.indexOf(x.id) !== -1) : [];
        }
        return [];
    }
}
